/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_Common_IntDropdownWithSystemNameDto } from '../models/Wealthlane_AwardService_Dtos_Common_IntDropdownWithSystemNameDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class GrantAgreementDocumentStatusService {

    /**
     * @returns Wealthlane_AwardService_Dtos_Common_IntDropdownWithSystemNameDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppGrantAgreementDocumentStatusGrantAgreementDocumentStatusDropdown(): CancelablePromise<Array<Wealthlane_AwardService_Dtos_Common_IntDropdownWithSystemNameDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/grant-agreement-document-status/grant-agreement-document-status-dropdown',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
